import { motion } from 'framer-motion';
import React, { useState, useEffect, useRef } from 'react';
import './machine_css.css';
import { pageVariants, pageTransition } from '../items/style/animationstyle';
import { ReactComponent as CartIcon } from '../Icons/Cart_icon.svg';
import { ReactComponent as PlusSign } from '../Icons/Plus_sign.svg';
import { ReactComponent as MinusSign } from '../Icons/Minus_sign.svg';
import CardBrands from '../Icons/Card_brands.png';
import { ReactComponent as CameraIcon } from '../Icons/Camera_icon.svg';

import { useHistory } from 'react-router';
import ProductSelection from './productSelection';
import { useTranslation } from 'react-i18next';
// import POSreceipt from './Invoices/POSreceipt';
import axios from 'axios';
import Keyboard from './items/keyboard';
import { HighlightOffRounded } from '@material-ui/icons';
import Cookies from 'js-cookie';
import logger from '../services/LocalServer/logger';
import Interested from './Interested';
import { currencyOptions } from '../staticData/options';
import request from '../services/Request';
import Swal from 'sweetalert2';
import MscCart from './company/MSC/mscCart';
import FAQ from './ShoppingCart/FAQ';

export default function CheckoutComponent(props) {
  const { t } = useTranslation();
  const isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';
  const { langs, itemCounter, MAXCARTNUM, stat, setStat, cleanUp } = props;

  let history = useHistory();
  const [error, setError] = useState('');
  const [isPromo, setIsPromo] = useState(false);
  //for onetime promotion

  const [mainL, setMainL] = useState('en-US');
  const [products, setProds] = useState([]);
  const [mycart, setmycart] = useState(null);
  const [mscResult, setmscResult] = useState(null);
  const [check, setcheck] = useState(true);
  const [showTerm, setShowTerm] = useState(false);
  // const [back, setback] = useState(true);

  const machineData = JSON.parse(localStorage.getItem('machine'));
  const hasTerm =
    machineData?.themeColor?.privacy?.length > 0 &&
    machineData?.themeColor?.privacy[0].content?.en?.length > 0;

  console.log('hasTerm', machineData?.themeColor);

  const HidePromo = localStorage.getItem('HIDE_PROMO') === 'TRUE';
  const HideTAX = localStorage.getItem('HIDE_TAX') === 'TRUE';
  const HideCards = localStorage.getItem('HIDE_CARDS') === 'TRUE';
  const msc = localStorage.getItem('MSC') === 'TRUE';
  const machineID = machineData._id;
  const tax = machineData.tax;
  const tax_rate = machineData.tax_rate;

  let symbol = JSON.parse(localStorage.getItem('machine'))?.currency?.symbol;
  symbol = symbol ? symbol : '$';

  const term = () => {
    setShowTerm(true);
  };

  const handleCheck = () => {
    setcheck(!check);
  };

  useEffect(() => {
    if (msc && props.cart.length > 0) {
      const resID = localStorage.getItem('MSC_RES');
      // {
      //   consumer: resID,
      //   externalCode: 'S0689700',
      //   quantity: 1,
      //   comment: 'this is the comment to display on the ticket',
      //   returnItem: false,
      //   voidItem: false,
      // },

      const mycart = props.cart.map((e) => {
        return {
          name: e.name[langs],
          comment: '',
          consumer: resID,
          externalCode: e.upc,
          quantity: e.quantity,
          returnItem: false,
          voidItem: false,
        };
      });
      setmycart(mycart);
      const runF1 = async () => {
        const result = await MscCart(mycart, true, true);
        console.log(result);
        if (!result) {
          Swal.fire({
            allowOutsideClick: false,
            text: `Could perform fast transaction to Otalio, please contact staff or try it again later`,
            icon: 'error',
          }).then(() => {});
          setTimeout(() => {
            cleanUp();
            Swal.close();
            history.push(`/machineUI/slider/${machineID}`);
          }, 4000);
        } else {
          if (result?.total > result?.balance) {
            Swal.fire({
              allowOutsideClick: false,
              text: `Not Enough Balance`,
              icon: 'error',
            }).then(() => {});
            setTimeout(() => {
              cleanUp();
              Swal.close();
              history.push(`/machineUI/slider/${machineID}`);
            }, 4000);
          } else {
            for (let i = 0; i < props.cart.length; i++) {
              props.cart[i].discountedPrice = result.cart[i].total;
              props.cart[i].hasDiscount = result.cart[i].checkTotal > result.cart[i].total;
              props.cart[i].checkTotal = result.cart[i].checkTotal;
            }
            console.log('props.cart', props.cart);
            Swal.close();
          }
        }

        setmscResult(result);
      };

      runF1();
    }
  }, [props.cart]);

  useEffect(() => {
    const mycoockie = Cookies.get('i18next');
    if (mycoockie === 'fr') {
      setMainL('fr-CA');
    } else if (mycoockie === 'es') {
      setMainL('es-US');
    }
    logger(2, 'Machine on cart page');
    //stat
    stat.cart_page += 1;
    setStat(stat);
    // console.log(stat);
  }, []);

  //keyboard
  const keyboard = useRef();
  const [input, setInput] = useState('');
  const [keyboardShow, setKeyboardShow] = useState(false);
  const onChangeInput = (event) => {
    const input = event.target.value;
    setInput(input);
    setError('');
    keyboard.current.setInput(input);
  };
  const handleClose = () => {
    setKeyboardShow(false);
  };
  const handleShow = () => {
    setKeyboardShow(true);
  };

  useEffect(() => {
    let prods = [...props.products];
    if (prods.length > 5) {
      prods.splice(4, prods.length);
    }
    props.cart.forEach((item) => {
      let index = products.findIndex((product) => product._id == item.id);
      if (index >= 0) {
        prods.splice(index, 1);
      }
    });
    setProds(prods);

    return () => {};
  }, []);

  const FinalProducts = props.cart.reduce((acc, item) => {
    item.price = parseFloat(item.price.toFixed(2));
    let newArray = [];
    const newItem = {
      picture: item.image,
      prodType: item.prodType,
      referTo: item.referTo,
      product: item.id,
      upc: item.upc,
      title: item.title,
      emailCode: item.emailCode,
      nextPurchase: item.nextPurchase,
      promo: item.promo,
      quantity: 1,
      tax: item.tax,
    };

    // item.discountedPrice = parseFloat(item.discountedPrice.toFixed(2));
    if (item?.buyX === 1) {
      if (item.quantity > 1) {
        for (var i = 0; i < item.quantity - 1; i++) {
          const new1 = { ...newItem };
          new1.item_id = Math.floor(10000000 + Math.random() * 90000000);
          new1.discount = 0;
          new1.promo = null;
          new1.soldPrice = parseFloat((item.price * (item.quantity - 1)).toFixed(2));
          newArray.push(new1);
        }
        const new2 = { ...newItem };
        new2.item_id = Math.floor(10000000 + Math.random() * 90000000);
        new2.discount = item.percentage
          ? parseFloat((item.discount * item.price).toFixed(2))
          : item.discount;
        new2.soldPrice = parseFloat(item.discountedPrice.toFixed(2));
        newArray.push(new2);
        return acc.concat(newArray);
      } else if (item.quantity === 1) {
        const new1 = { ...newItem };
        new1.item_id = Math.floor(10000000 + Math.random() * 90000000);
        new1.discount = item.percentage
          ? parseFloat((item.discount * item.price).toFixed(2))
          : item.discount;
        new1.soldPrice = parseFloat(item.discountedPrice.toFixed(2));
        return acc.concat([new1]);
      }
    } else if (item.buyX > 1) {
      for (var i = 0; i < item.quantity; i++) {
        const new1 = { ...newItem };
        new1.item_id = Math.floor(10000000 + Math.random() * 90000000);
        if (item.promoQtt < item.buyX) {
          new1.discount = 0;
          new1.soldPrice = parseFloat((item.price * (item.quantity - 1)).toFixed(2));
        }
        if (item.promoQtt >= item.buyX) {
          new1.discount = parseFloat((item.discount * item.price * item.quantity).toFixed(2));
          new1.soldPrice = parseFloat((item.discountedPrice * item.quantity).toFixed(2));
          if (item.promoQtt % item.buyX === 0) {
            if (!item.percentage) {
              new1.discount = parseFloat((item.discount / item.buyX).toFixed(2));
              new1.soldPrice = parseFloat(
                (item.price - parseFloat((item.discount / item.buyX).toFixed(2))).toFixed(2)
              );
            }
          } else {
            if (!item.percentage) {
              new1.discount = parseFloat((item.discount / item.promoQtt).toFixed(2));
              new1.soldPrice = parseFloat(
                (item.price - parseFloat((item.discount / item.promoQtt).toFixed(2))).toFixed(2)
              );
            }
          }
        }
        newArray.push(new1);
      }

      return acc.concat(newArray);
    } else {
      for (var i = 0; i < item.quantity; i++) {
        const new1 = { ...newItem };
        new1.item_id = Math.floor(10000000 + Math.random() * 90000000);
        if (msc) {
          new1.discount = parseFloat(
            ((item.checkTotal - item.discountedPrice) / item.quantity).toFixed(2)
          );
        } else {
          new1.discount = item.percentage
            ? parseFloat((item.discount * item.price * item.quantity).toFixed(2))
            : item.discount * item.quantity;
        }

        new1.soldPrice = parseFloat(item.discountedPrice.toFixed(2));
        newArray.push(new1);
      }
      return acc.concat(newArray);
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {
      // clearInterval(outInterval);
    };
  }, []);

  useEffect(() => {
    if (props.cart.length == 0) {
      if (localStorage.getItem('codePromo')) localStorage.setItem('codePromo', null);
      if (localStorage.getItem('oneTime')) localStorage.setItem('oneTime', null);
    }
  }, [props.cart.length]);

  let totalPrice = 0;
  let finalTax = 0;

  const calculateitemPrice = (item) => {
    if (msc && item.hasDiscount) {
      return (
        <div>
          <span style={{ textDecoration: 'line-through' }}>
            {mainL != 'fr-CA' && symbol}
            {parseFloat((item.price * item.quantity).toFixed(2)).toLocaleString(
              mainL,
              currencyOptions
            )}
            {mainL == 'fr-CA' && symbol}
          </span>
          <span style={{ marginLeft: '20px' }}>
            {mainL != 'fr-CA' && symbol}
            {parseFloat(item.discountedPrice.toFixed(2)).toLocaleString(mainL, currencyOptions)}
            {mainL == 'fr-CA' && symbol}
          </span>
        </div>
      );
    }

    return (
      <span>
        {mainL != 'fr-CA' && symbol}
        {parseFloat((item.price * item.quantity).toFixed(2)).toLocaleString(mainL, currencyOptions)}
        {mainL == 'fr-CA' && symbol}
      </span>
    );
  };

  const calculateDiscount = (cart) => {
    if (msc) {
      return getPrice(cart) - mscResult?.total;
    }
    const discount = cart.reduce((totalCost, item) => {
      if (item?.buyX > 1) {
        if (item.promoQtt === 1) {
          return totalCost;
        }
        if (item.promoQtt > 1) {
          if (item.promoQtt % item.buyX === 0) {
            if (item.percentage) {
              return (
                totalCost +
                parseFloat(
                  (item.price * item.quantity - item.discountedPrice * item.quantity).toFixed(2)
                )
              );
            } else {
              return (
                totalCost + parseFloat(((item.quantity * item.discount) / item.buyX).toFixed(2))
              );
            }
          } else {
            if (item.promoQtt < item.buyX) return totalCost;
            else {
              if (item.percentage == true) {
                return (
                  totalCost +
                  parseFloat(
                    (item.price * item.quantity - item.discountedPrice * item.quantity).toFixed(2)
                  )
                );
              } else {
                return (
                  totalCost +
                  parseFloat(((item.quantity * item.discount) / item.promoQtt).toFixed(2))
                );
              }
            }
          }
        } else return totalCost;
      } else if (item.buyX === 1) {
        if (item.discount != 0)
          return totalCost + parseFloat((item.price - item.discountedPrice).toFixed(2));
        else return totalCost;
      } else {
        if (item.discount > 0) {
          return (
            totalCost + parseFloat(((item.price - item.discountedPrice) * item.quantity).toFixed(2))
          );
        } else {
          return totalCost;
        }
      }
    }, 0);
    return discount;
  };

  const calculateSub = (cart) => {
    if (msc) {
      return mscResult?.total;
    }
    const total = cart.reduce((totalCost, item) => {
      let result = 0;
      if (item?.buyX > 1) {
        if (item.quantity === 1) {
          result = item.price;
        }
        if (item.quantity > 1) {
          if (item.quantity % item.buyX === 0) {
            if (item.percentage) {
              result =
                parseFloat((item.price * item.quantity).toFixed(2)) -
                parseFloat((item.price * item.quantity * item.discount).toFixed(2));
            } else {
              result =
                parseFloat((item.price * item.quantity).toFixed(2)) -
                parseFloat((item.discount * item.pQuantity).toFixed(2));
            }
          } else {
            if (item.quantity < item.buyX) {
              result = parseFloat((item.price * item.quantity).toFixed(2));
            } else {
              if (item.percentage == true) {
                result =
                  parseFloat((item.price * item.quantity).toFixed(2)) -
                  parseFloat((item.price * item.quantity * item.discount).toFixed(2));
              } else {
                result = parseFloat(
                  (
                    item.price * item.buyX * item.pQuantity -
                    item.discount +
                    item.price * (item.quantity - item.buyX * item.pQuantity)
                  ).toFixed(2)
                );
              }
            }
          }
        }
      } else if (item.buyX === 1) {
        result = parseFloat((item.discountedPrice + item.price * (item.quantity - 1)).toFixed(2));
      } else {
        result = parseFloat((item.discountedPrice * item.quantity).toFixed(2));
      }

      // apply tax
      if (!tax && typeof tax_rate?.typeA === 'number') {
        console.log('result', result);
        // console.log('tax_rate', tax_rate);
        if (item.tax_type === '1') {
          item.tax = parseFloat(
            ((parseFloat(result) * tax_rate.typeB) / item.quantity / 100).toFixed(2)
          );
        } else if (item.tax_type === '2') {
          item.tax = parseFloat(
            ((parseFloat(result) * tax_rate.typeC) / item.quantity / 100).toFixed(2)
          );
        } else if (item.tax_type === '3') {
          item.tax = parseFloat(
            ((parseFloat(result) * tax_rate.typeD) / item.quantity / 100).toFixed(2)
          );
          // typeA is the default tax rate
        } else {
          item.tax = parseFloat(
            ((parseFloat(result) * tax_rate.typeA) / item.quantity / 100).toFixed(2)
          );
        }
      } else {
        // console.log('tax');
        item.tax = parseFloat(((parseFloat(result) * tax) / item.quantity / 100).toFixed(2));
      }
      return totalCost + result;
    }, 0);
    return total;
  };

  const getPrice = (cart) => {
    const total = cart.reduce((totalCost, item) => {
      return (totalCost += parseFloat((item.price * item.quantity).toFixed(2)));
    }, 0);
    return total;
  };

  function getPirceString(cart) {
    const total = getPrice(cart);
    return total.toLocaleString(mainL, currencyOptions);
  }

  function getSubTotal(cart) {
    const total = calculateSub(cart);
    return total.toLocaleString(mainL, currencyOptions);
  }

  function getDiscountTotal(cart) {
    const total = calculateDiscount(cart);
    return total.toLocaleString(mainL, currencyOptions);
  }

  function getTotal(cart) {
    let subtotal = calculateSub(cart);
    subtotal = parseFloat(subtotal.toFixed(2));

    finalTax = cart.reduce((totalCost, item) => {
      return totalCost + item.tax * item.quantity;
    }, 0);

    let total = subtotal + finalTax;
    total = parseFloat(total.toFixed(2));
    totalPrice = total;
    return total.toLocaleString(mainL, currencyOptions);
  }

  function getFinalTax(cart) {
    const tax = cart.reduce((totalCost, item) => {
      return totalCost + item.tax * item.quantity;
    }, 0);
    return tax.toLocaleString(mainL, currencyOptions);
  }

  const items = props.cart.map((item) => {
    const Fname =
      item.title[langs] && item.title[langs] !== '' ? item.title[langs] : item.title?.en;

    const url = isLocal
      ? `${process.env.REACT_APP_LOCAL_API}/pictures/products/${item.image}`
      : `${process.env.REACT_APP_SERVER_API}/pictures/${item.image}/${item.referTo}`;
    return (
      <div key={item.id} className="cart-item-style">
        <div
          style={{
            border: '1em solid white',
            borderRadius: '15px',
            margin: '1em',
            boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
          }}
        >
          <div
            style={
              props.cart.length <= 2
                ? {
                    width: '250px',
                    height: '200px',
                    backgroundColor: 'white',
                  }
                : {
                    width: '150px',
                    height: '120px',
                    backgroundColor: 'white',
                  }
            }
          >
            <img className="cart-item-image" src={url} alt="Product's image" />
          </div>
        </div>
        <div
          className="d-flex"
          style={
            props.cart.length <= 2
              ? {
                  textAlign: 'start',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'start',
                  minWidth: '400px',
                  paddingLeft: '30px',
                }
              : {
                  textAlign: 'start',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'start',
                  minWidth: '400px',
                }
          }
        >
          <span
            className="cat-title"
            style={{
              fontSize: '28px',
            }}
          >
            {Fname}
          </span>
          <span className="cart-price">{calculateitemPrice(item)}</span>
        </div>
        <div
          className="d-flex"
          style={{
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            marginRight: '3em',
          }}
        >
          <MinusSign
            height={50}
            className="svg-style-color mr-3"
            onClick={() => {
              if (item.prodType === 'prod') {
                props.decreStock(
                  props.products[item.idx],
                  props.products[item.idx].current_stock + 1
                );
                // cartAnimation();
                if (item.quantity === 1) {
                  // logger(2, `${props.products[item.idx].name?.en} has been removed to cart.`);
                  props.remove({ id: item.id });
                } else {
                  // logger(2, `1 ${props.products[item.idx].name?.en} has been removed to cart.`);
                  props.alterQuantity({ id: item.id }, item.quantity - 1);
                }
              } else {
                // cartAnimation();
                if (item.quantity === 1) {
                  props.remove({ id: item.id });
                } else {
                  props.alterQuantity({ id: item.id }, item.quantity - 1);
                }
              }
            }}
          />
          <div className="cart-item-counter">{item.quantity}</div>
          {props.products[item.idx] &&
          props.products[item.idx].current_stock > 0 &&
          itemCounter < MAXCARTNUM ? (
            <PlusSign
              height={50}
              className="svg-style-color ml-3"
              onClick={() => {
                if (item.prodType === 'prod') {
                  if (props.products[item.idx].current_stock > 0) {
                    // logger(
                    //   2,
                    //   `1 more ${props.products[item.idx].name?.en} has been added to cart.`
                    // );
                    // cartAnimation(true);
                    props.alterQuantity({ id: item.id }, item.quantity + 1);
                    props.decreStock(
                      props.products[item.idx],
                      props.products[item.idx].current_stock - 1
                    );
                  }
                } else {
                  // cartAnimation(true);
                  props.alterQuantity({ id: item.id }, item.quantity + 1);
                }
              }}
            />
          ) : (
            <div className="mr-3" style={{ height: '50px', width: '50px' }}></div>
          )}
        </div>
      </div>
    );
  });

  const emptyCart = () => {
    return (
      <div
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          color: '#2a5989',
          fontSize: '50px',
        }}
        className="d-flex cart-item-style empty-cart"
      >
        {t(`Your cart is empty`)}...
      </div>
    );
  };

  const clearPromotion = () => {
    setError('');
    // logger(2, `All promotions has been cleared`);
    setInput('');
    if (localStorage.getItem('codePromo')) localStorage.setItem('codePromo', null);
    if (localStorage.getItem('oneTime')) localStorage.setItem('oneTime', null);
    for (let i = 0; i < props.cart.length; i++) {
      const index = props.products.findIndex((e) => props.cart[i]._id === e._id);
      console.log(products[index]);
      if (index > -1) {
        props.changePrice(
          { id: props.cart[i].id },
          products[index].discount ? products[index].discount : 0,
          products[index].discountedPrice ? products[index].discountedPrice : products[index].price,
          products[index].buyX ? products[index].buyX : 0,
          products[index].percentage,
          products[index].promo
        );
      }
    }
    setError('');
    setIsPromo(false);
  };

  const onPromoSubmit = async (e) => {
    // await request({
    //   method: 'post',
    //   url: '',
    //   data: {
    //     machine: machineID,
    //     code: '',
    //   },
    // }).then((res) => {});
    const promoData = JSON.parse(localStorage.getItem('promo'));
    let isFound = false;
    let promoCode = '';
    if (promoData) {
      promoData.forEach(async (e) => {
        if (e.promoType === 'generalWithCode') {
          if (e.code === input) {
            setIsPromo(true);
            isFound = true;
            if (e.cateOrProd === 'All Products') {
              props.cart.forEach((item) => {
                const disPrice = e.percentage
                  ? item.price - item.price * e.amount
                  : item.price - e.amount;
                props.changePrice({ id: item.id }, e.amount, disPrice, 0, e.percentage, e._id);
              });
            }
            if (e.cateOrProd === 'cate') {
              if (e.category) {
                for (let i = 0; i < e.category.length; i++) {
                  for (let j = 0; j < props.cart.length; j++) {
                    if (props.cart[j].category.includes(e.category[i]._id)) {
                      const disPrice = e.percentage
                        ? props.cart[j].price - props.cart[j].price * e.amount
                        : props.cart[j].price - e.amount;
                      props.changePrice(
                        { id: props.cart[j].id },
                        e.amount,
                        disPrice,
                        0,
                        e.percentage,
                        e._id
                      );
                    }
                  }
                }
              }
            } else if (e.cateOrProd === 'prod') {
              if (e.product) {
                for (let i = 0; i < e.product.length; i++) {
                  for (let j = 0; j < props.cart.length; j++) {
                    if (e.product[i]._id == props.cart[j].id) {
                      const disPrice = e.percentage
                        ? props.cart[j].price - props.cart[j].price * e.amount
                        : props.cart[j].price - e.amount;
                      props.changePrice(
                        { id: props.cart[j].id },
                        e.amount,
                        disPrice,
                        0,
                        e.percentage,
                        e._id
                      );
                    }
                  }
                }
              }
            }
            return;
          }
        }

        if (e.promoType === 'oneTime' || e.promoType === 'nextPurchase') {
          if (e.oneTimeCode.includes(input)) {
            isFound = true;
            //send request to database check
            await request({
              method: 'post',
              url: '/promos/authCode',
              data: {
                promo: e._id,
                input: input,
              },
              timeout: 5000,
            })
              .then((res) => {
                let noFound = false;
                e.input = input;
                localStorage.setItem('oneTime', JSON.stringify(e));
                if (e.cateOrProd === 'All Products') {
                  setIsPromo(true);
                  const firstProd = props.cart[0];
                  const disPrice = e.percentage
                    ? firstProd.price - firstProd.price * e.amount
                    : firstProd.price - e.amount;
                  props.changePrice(
                    { id: firstProd.id },
                    e.amount,
                    disPrice,
                    0,
                    e.percentage,
                    e._id
                  );
                }
                if (e.cateOrProd === 'cate') {
                  if (e.category) {
                    for (let j = 0; j < props.cart.length; j++) {
                      for (let i = 0; i < e.category.length; i++) {
                        if (props.cart[j].category.includes(e.category[i]._id)) {
                          const disPrice = e.percentage
                            ? props.cart[j].price - props.cart[j].price * e.amount
                            : props.cart[j].price - e.amount;
                          props.changePrice(
                            { id: props.cart[j].id },
                            e.amount,
                            disPrice,
                            0,
                            e.percentage,
                            e._id
                          );
                          setIsPromo(true);
                          return;
                        }
                      }
                    }
                    noFound = true;
                  }
                } else if (e.cateOrProd === 'prod') {
                  if (e.product) {
                    for (let j = 0; j < props.cart.length; j++) {
                      for (let i = 0; i < e.product.length; i++) {
                        if (e.product[i]._id == props.cart[j].id) {
                          const disPrice = e.percentage
                            ? props.cart[j].price - props.cart[j].price * e.amount
                            : props.cart[j].price - e.amount;
                          props.changePrice(
                            { id: props.cart[j].id },
                            e.amount,
                            disPrice,
                            0,
                            e.percentage,
                            e._id
                          );
                          setIsPromo(true);
                          return;
                        }
                      }
                    }
                  }
                  noFound = true;
                }
                if (noFound) {
                  setError(t('No products refer to this code'));
                }
              })
              .catch(() => {
                setError(t('The code is not valid'));
              });
          }
        }
      });

      if (!isFound) {
        // logger(1, 'A invalid promote code has been entered');
        setError(t('The code is not valid'));
      }
    }
  };

  const onBarcodeSubmit = () => {
    alert('barcode reader is not ready yet');
  };

  const checkout = async () => {
    let go = true;
    if (items.length <= 0) {
      go = false;
    }

    if (go) {
      localStorage.setItem('TotalPrice', parseFloat(totalPrice));
      localStorage.setItem('FinalTax', parseFloat(finalTax));
      localStorage.setItem('FinalProducts', JSON.stringify(FinalProducts));
      const items = FinalProducts.reduce((acc, product) => {
        const tax_amount = product.tax;
        const array = [];
        for (let i = 0; i < product.quantity; i++) {
          const FprodName =
            product.title[langs] && product.title[langs] !== ''
              ? product.title[langs]
              : product.title?.en;

          array.push({
            item_id: Math.floor(10000000 + Math.random() * 90000000),
            product_name: FprodName,
            upc: product.upc,
            quantity: 1,
            soldPrice: product.soldPrice / product.quantity,
            tax_amount: tax_amount,
            product: product.product,
            emailCode: product.emailCode,
            nextPurchase: product.nextPurchase,
            prodType: product.prodType,
            discount: product.discount / product.quantity,
            referTo: product.referTo,
            picture: product.picture,
            promo: product.promo,
            total_amount: parseFloat(
              (product.soldPrice / product.quantity + tax_amount).toFixed(2)
            ),
          });
        }
        return acc.concat(array);
      }, []);
      localStorage.setItem('SeparateItem', JSON.stringify(items));
      let order_info = {
        order_id: Math.floor(10000000 + Math.random() * 90000000),
        item_amount: FinalProducts.length,
        tax_amount: finalTax,
        total_amount: totalPrice,
        items: items,
      };
      console.log('SeparateItem', items);
      logger(2, 'Items going to Dispense = ', JSON.stringify(items));
      if (!props.testMode) {
        await axios
          .post(
            `${process.env.REACT_APP_LOCAL_API}/updateKioskStatus`,
            {
              status: 'OrderCreated',
              order_info: order_info,
            },
            {
              headers: {
                'X-CompanyID': 'magex',
                'X-Token': process.env.REACT_APP_X_TOKEN,
              },
            }
          )
          .then(() => {
            if (localStorage.getItem('SKIP_PAYMENT') === 'TRUE') {
              history.push(`/machineUI/product-dispense/${machineID}`);
            } else {
              history.push(`/machineUI/payment/${machineID}`);
            }
          });
        // history.push(`/machineUI/product-dispense/${machineID}`);
      } else {
        history.push(`/machineUI/product-dispense/${machineID}`);
      }
    }
  };

  return (
    <div className="category-container">
      <motion.div
        key="product-div"
        className="container"
        initial="initial"
        exit="out"
        animate="in"
        variants={pageVariants}
        transition={pageTransition}
      >
        <div className="row justify-content-center mb-5">
          <span className="cat-title mt-5">{t('Cart').toUpperCase()}</span>
        </div>
        <div className="d-flex justify-content-left align-items-center">
          <span className="cat-title">{t('My Cart List')}</span>
          <CartIcon height={50} className="svg-style-color ml-3" />
        </div>
        {items.length > 0 ? items : emptyCart()}
        {!HidePromo && (
          <div>
            <div
              className="d-flex flex-column align-items-end justify-content-end mt-4 cart-checkout-error"
              error={error}
            >
              <input
                type="search"
                placeholder={t(`Discount Code`)}
                value={input}
                onClick={handleShow}
                onChange={onChangeInput}
                aria-label="Search"
                className="promo-input"
                disabled={isPromo}
              />
              <Keyboard
                show={keyboardShow}
                setShow={setKeyboardShow}
                handleClose={handleClose}
                input={input}
                setInput={setInput}
                keyboard={keyboard}
              />
            </div>
            <div className="d-flex justify-content-end mt-4">
              <div
                className="row"
                style={{
                  width: '37%',
                  justifyContent: 'space-between',
                  marginRight: 0,
                  flexWrap: 'nowrap',
                }}
              >
                <div
                  style={{
                    marginLeft: 0,
                    minHeight: '60px',
                    paddingLeft: '1.3rem',
                    paddingRight: '1.3rem',
                  }}
                  className="apply-promo-button d-flex align-items-center"
                  type="button"
                  onClick={onBarcodeSubmit}
                >
                  <CameraIcon className="camera_icon" />{' '}
                  <strong
                    style={{
                      fontSize: '18px',
                    }}
                  >
                    {t('QR CODE SCAN')}
                  </strong>
                </div>
                {!isPromo && (
                  <button
                    style={{
                      minHeight: '60px',
                      fontSize: '17px',
                    }}
                    className="apply-promo-button"
                    type="button"
                    onClick={onPromoSubmit}
                  >
                    {t(`Apply`)}
                  </button>
                )}
                {isPromo && (
                  <button className="apply-promo-button" type="button" onClick={clearPromotion}>
                    {t('Clear Promotions')}
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        <div style={{ width: '100%', minHeight: '300px' }}>
          <div className="total-div">
            <div
              className="mt-4 cat-title"
              style={{
                minHeight: '38px',
                fontSize: '35px',
              }}
            >
              <p>
                <span style={{ float: 'left' }}>{t(`Subtotal`)}: </span>
                <span style={{ float: 'right' }}>
                  {mainL != 'fr-CA' && symbol}
                  {getPirceString(props.cart)}
                  {mainL == 'fr-CA' && symbol}
                </span>
              </p>
            </div>
            <div
              className="cat-title"
              style={{
                minHeight: '38px',
                fontSize: '35px',
              }}
            >
              <p>
                <span style={{ float: 'left' }}>{t(`Discount`)}: </span>
                <span style={{ float: 'right' }}>
                  {mainL != 'fr-CA' && symbol}
                  {getDiscountTotal(props.cart)}
                  {mainL == 'fr-CA' && symbol}
                </span>
              </p>
            </div>
            {!HideTAX && (
              <div
                className="cat-title"
                style={{
                  minHeight: '38px',
                  fontSize: '35px',
                }}
              >
                <p>
                  <span style={{ float: 'left' }}>{t('Taxes')}: </span>
                  <span style={{ float: 'right' }}>
                    {mainL != 'fr-CA' && symbol}
                    {getFinalTax(props.cart)}
                    {mainL == 'fr-CA' && symbol}
                  </span>
                </p>
              </div>
            )}

            <div className="horizontal_dotted_line" style={{ marginTop: '30px' }}></div>
            <div
              className="cat-title"
              style={{
                minHeight: '38px',
                fontSize: '35px',
              }}
            >
              <p>
                <span style={{ float: 'left' }}>{t(`Total`)}:</span>
                <span style={{ float: 'right' }}>
                  {mainL != 'fr-CA' && symbol}
                  {getTotal(props.cart)}
                  {mainL == 'fr-CA' && symbol}
                </span>
              </p>
            </div>
          </div>
        </div>
        <div style={{ display: 'block' }}>
          {(check || !hasTerm) && (
            <div style={{ display: 'block' }}>
              {(check || !hasTerm) && (
                <div>
                  <div className="d-flex justify-content-end align-items-center mt-4">
                    <span
                      className="cart-checkout-button ml-4"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          checkout();
                        }
                      }}
                      id="check-out-button"
                      onClick={checkout}
                      tabIndex="0"
                      role="button"
                    >
                      {t(`Checkout`)}
                    </span>
                  </div>
                  {/* )} */}
                </div>
              )}
            </div>
          )}
          {hasTerm && (
            <div className="mt-3 buttonColor d-flex justify-content-end align-items-center">
              <input
                type="checkbox"
                checked={check}
                onChange={handleCheck}
                className="checkboxColor mr-3"
              />
              <span style={{ fontSize: '24px', marginRight: '9px' }} onClick={term}>
                {t(`I agree to the`)}
              </span>
              <span style={{ fontSize: '24px', fontWeight: 'bold' }} onClick={term}>
                {t(`Terms and Conditions`)}
              </span>
            </div>
          )}
        </div>

        <Interested products={products} machineID={machineID} prods={products} t={t} />

        <HighlightOffRounded
          style={{ fontSize: '60px' }}
          className="desc_close_circle_icon"
          onClick={() => {
            history.push(`/machineUI/category/all/All Products/${machineID}`);
          }}
        />
      </motion.div>

      {/* <ProductSelection
        langs={langs}
        show={show}
        onetimeArray={onetimeArray}
        setOnetimeID={setOnetimeID}
        onHide={() => setShow(false)}
      /> */}
      {/* <POSreceipt /> */}
      <FAQ show={showTerm} setShow={setShowTerm} langs={langs} />
    </div>
  );
}
